import SecurityPolicyPage from 'screens/Contract/SecurityPolicy/SecurityPolicy';

export default SecurityPolicyPage;
